import { render, staticRenderFns } from "./Tabs.component.vue?vue&type=template&id=5786fbba&scoped=true"
import script from "./Tabs.component.vue?vue&type=script&lang=js"
export * from "./Tabs.component.vue?vue&type=script&lang=js"
import style0 from "./Tabs.component.vue?vue&type=style&index=0&id=5786fbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786fbba",
  null
  
)

export default component.exports